import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const SCMenu = styled.div`
  background-color: ${(p) => p.theme.color.white};
  height: calc(100vh - 60px);
  margin-bottom: ${(p) => (p.open ? '-60px' : '0')};
  overflow-y: scroll;
  padding: ${(p) => p.theme.spacing(1)}};
  position: fixed;
  transform: ${(p) => (p.open ? 'translateX(0)' : 'translateX(-100%)')};
  transition: all 0.2s ease-in-out;
  width: 70%;
  z-index: 10000;

  & > * + * {
    margin-top: ${(p) => p.theme.spacing(3)};
  }

  @media (${(p) => p.theme.mq.desktop}) {
    background-color: transparent;
    height: auto;
    overflow: auto;
    padding: 10px 0;
    position: static;
    transform: translateX(0);
    width: 300px;

    & > * + * {
      margin-top: ${(p) => p.theme.spacing(6)};
    }
  }
`;

export const SCMenuHeader = styled.h4`
  color: ${(p) => p.theme.color.grayDark};
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  margin: 0;
  padding: ${(p) => p.theme.spacing(2)};
  text-transform: uppercase;

  @media (${(p) => p.theme.mq.desktop}) {
    padding: ${(p) => p.theme.spacing(2)} ${(p) => p.theme.spacing(2)}
      ${(p) => p.theme.spacing(2)} 0;
  }
`;

export const SCMenuItem = styled(({ ...rest }) => <NavLink {...rest} />)`
  border-radius: ${(p) => p.theme.base.borderRadius};
  color: black;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  justify-content: space-between;
  line-height: 1;
  padding: ${(p) => p.theme.spacing(2)};
  margin: 0;
  text-decoration: none;
  opacity: ${(p) => (p.disabled ? '0.5' : '1')};

  @media (${(p) => p.theme.mq.desktop}) {
    padding: ${(p) => p.theme.spacing(2)} ${(p) => p.theme.spacing(2)}
      ${(p) => p.theme.spacing(2)} 0;
    &:hover {
      background-color: ${(p) =>
        p.disabled ? '' : p.theme.rgba('blueLight', 0.5)};
    }
  }

  &.${(p) => p.activeClassName} {
    font-weight: 600;
  }

  svg {
    height: 16px;
  }
`;

export const LogoutButton = styled.p`
  color: ${(p) => p.theme.color.red};
  cursor: pointer;
  padding: ${(p) => p.theme.spacing(2)};

  &:hover {
    background-color: ${(p) => p.theme.rgba('blueLight', 0.5)};
  }
`;

export const CancelButton = styled.p`
  color: ${(p) => p.theme.color.red};
  cursor: pointer;
  margin-top: ${(p) => p.theme.spacing(8)};
  padding: ${(p) => p.theme.spacing(2)};

  &:hover {
    background-color: ${(p) => p.theme.rgba('blueLight', 0.5)};
  }

  @media (${(p) => p.theme.mq.desktop}) {
    padding: ${(p) => p.theme.spacing(2)} ${(p) => p.theme.spacing(2)};
  }
`;



// WEBPACK FOOTER //
// ./src/components/Menu/styles.js